/** A client's access, said the same way on every screen that lists clients. */
import type { BadgeTone } from "@/design-system/StatusBadge";
import type { PlatformClientResponse } from "@/shared/api";

export const ACCESS: Record<PlatformClientResponse["access"], { readonly tone: BadgeTone; readonly text: string }> = {
  ACTIVE: { tone: "ready", text: "Доступ активирован" },
  INVITED: { tone: "active", text: "Приглашён" },
  INVITATION_EXPIRED: { tone: "warning", text: "Приглашение истекло" },
  NO_ACCESS: { tone: "muted", text: "Нет доступа" },
};
